import React, { useState, useEffect } from 'react';
import { ChevronRight, ChevronLeft, Search, Brain, Heart, Users, TrendingUp, Target, Sparkles, Clock, AlertCircle, CheckCircle, ArrowRight } from 'lucide-react';

const MindaeraPitchDeck = () => {
	const [currentSlide, setCurrentSlide] = useState(0);
const [touchStart, setTouchStart] = useState(null);
const [touchEnd, setTouchEnd] = useState(null);

// Minimum swipe distance (in pixels)
const minSwipeDistance = 50;

const onTouchStart = (e) => {
	setTouchEnd(null);
	setTouchStart(e.targetTouches[0].clientX);
};

const onTouchMove = (e) => {
	setTouchEnd(e.targetTouches[0].clientX);
};

const onTouchEnd = () => {
	if (!touchStart || !touchEnd) return;
	
	const distance = touchStart - touchEnd;
	const isLeftSwipe = distance > minSwipeDistance;
	const isRightSwipe = distance < -minSwipeDistance;
	
	if (isLeftSwipe && currentSlide < slides.length - 1) {
		nextSlide();
	}
	if (isRightSwipe && currentSlide > 0) {
		prevSlide();
	}
};
	const slides = [
		// Slide 1: Title
		{
			id: 'title',
			content: (
				<div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-600 via-purple-600 to-blue-700">
					<div className="text-center px-8 max-w-6xl mx-auto">
						<div className="mb-8">
							<div className="w-20 h-20 bg-white rounded-2xl flex items-center justify-center mx-auto mb-6">
								<Brain className="w-12 h-12 text-purple-600" />
							</div>
						</div>
						<h1 className="text-6xl md:text-8xl font-bold mb-6 text-white">
							Mindaera
						</h1>
						<p className="text-2xl md:text-3xl text-blue-100 mb-12 font-light">
							Find the right therapist in minutes
						</p>
						<p className="text-lg text-blue-200 animate-pulse">
							A story of transformation in mental healthcare
						</p>
					</div>
				</div>
			)
		},

		// Slide 2: Meet Sarah
		{
			id: 'meet-sarah',
			content: (
				<div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-600 via-purple-600 to-blue-700">
					<div className="max-w-5xl mx-auto px-8">
						<h2 className="text-5xl md:text-6xl font-bold mb-12 text-white text-center">
							Meet Sarah
						</h2>
						<div className="bg-white rounded-3xl p-12 shadow-2xl">
							<div className="grid md:grid-cols-2 gap-8 items-center">
								<div>
									<p className="text-gray-700 text-lg mb-6">
										Sarah is 28, works in marketing, and has been feeling overwhelmed lately.
									</p>
									<p className="text-gray-700 text-lg mb-6">
										Her anxiety is affecting her work and relationships.
									</p>
									<p className="text-gray-700 text-lg font-semibold">
										She knows she needs help, but where does she even start?
									</p>
								</div>
								<div className="flex items-center justify-center">
									<div className="w-48 h-48 bg-gradient-to-br from-purple-100 to-blue-100 rounded-full flex items-center justify-center">
										<Heart className="w-24 h-24 text-purple-600" />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)
		},
		// New Slide 3: Sarah's Journey (insert after "Meet Sarah" and before "The Dirty Truth")
{
    id: 'sarahs-journey',
    content: (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-800 to-gray-900">
            <div className="max-w-5xl mx-auto px-8">
                <h2 className="text-4xl md:text-5xl font-bold mb-12 text-white text-center">
                    Sarah Tries to Find Help
                </h2>
                <div className="space-y-6">
                    {/* Day 1 */}
                    <div className="bg-white bg-opacity-10 backdrop-blur-lg rounded-2xl p-6 border border-white border-opacity-20">
                        <div className="flex items-start space-x-4">
                            <div className="w-12 h-12 bg-purple-500 rounded-full flex items-center justify-center flex-shrink-0">
                                <span className="text-white font-bold">1</span>
                            </div>
                            <div className="flex-1">
                                <h3 className="text-xl font-semibold text-white mb-2">Monday Evening</h3>
                                <p className="text-gray-300">
                                    "I'll just Google 'therapist near me'... Oh wow, 847 results. 
                                    Let me try this app everyone talks about..."
                                </p>
                            </div>
                        </div>
                    </div>
                    
                    {/* Day 3 */}
                    <div className="bg-white bg-opacity-10 backdrop-blur-lg rounded-2xl p-6 border border-white border-opacity-20">
                        <div className="flex items-start space-x-4">
                            <div className="w-12 h-12 bg-purple-500 rounded-full flex items-center justify-center flex-shrink-0">
                                <span className="text-white font-bold">3</span>
                            </div>
                            <div className="flex-1">
                                <h3 className="text-xl font-semibold text-white mb-2">Wednesday Night</h3>
                                <p className="text-gray-300">
                                    "Took their quiz. Got matched with 3 therapists who all seem... the same? 
                                    One specializes in 'everything.' Is that even possible?"
                                </p>
                            </div>
                        </div>
                    </div>
                    
                    {/* Day 7 */}
                    <div className="bg-white bg-opacity-10 backdrop-blur-lg rounded-2xl p-6 border border-white border-opacity-20">
                        <div className="flex items-start space-x-4">
                            <div className="w-12 h-12 bg-purple-500 rounded-full flex items-center justify-center flex-shrink-0">
                                <span className="text-white font-bold">7</span>
                            </div>
                            <div className="flex-1">
                                <h3 className="text-xl font-semibold text-white mb-2">Sunday Afternoon</h3>
                                <p className="text-gray-300">
                                    "First session was... awkward. She kept asking about my childhood trauma. 
                                    I just wanted help with work stress. Maybe I'll try another app?"
                                </p>
                            </div>
                        </div>
                    </div>
                    
                    {/* The Realization */}
                    <div className="bg-red-900 bg-opacity-30 backdrop-blur-lg rounded-2xl p-8 border border-red-500 border-opacity-30 text-center">
                        <p className="text-2xl text-white font-semibold mb-2">
                            Two weeks. Three apps. Zero connection.
                        </p>
                        <p className="text-lg text-red-300">
                            "Maybe the problem is me..."
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
},
// Revised Slide 4: The Broken System (replaces "The Dirty Truth")
{
    id: 'broken-system',
    content: (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 to-gray-800">
            <div className="max-w-6xl mx-auto px-8">
                <h2 className="text-4xl md:text-5xl font-bold mb-8 text-white text-center">
                    Why Sarah's Story is Everyone's Story
                </h2>
                
                <div className="bg-white rounded-3xl p-8 shadow-2xl mb-8">
                    <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">
                        The Current Mental Health Tech Landscape
                    </h3>
                    
                    <div className="grid md:grid-cols-2 gap-6 mb-8">
                        <div className="bg-gray-50 rounded-xl p-6">
                            <h4 className="font-bold text-gray-800 mb-4 flex items-center">
                                <span className="text-2xl mr-2">📱</span> The Apps
                            </h4>
                            <ul className="space-y-3 text-gray-700">
                                <li className="flex items-start">
                                    <span className="text-gray-400 mr-2">•</span>
                                    <div>
                                        <span className="font-semibold">Matching on availability</span>, not compatibility
                                    </div>
                                </li>
                                <li className="flex items-start">
                                    <span className="text-gray-400 mr-2">•</span>
                                    <div>
                                        <span className="font-semibold">Generic questionnaires</span> that miss what matters
                                    </div>
                                </li>
                                <li className="flex items-start">
                                    <span className="text-gray-400 mr-2">•</span>
                                    <div>
                                        <span className="font-semibold">Therapist burnout</span> from poor matches
                                    </div>
                                </li>
                            </ul>
                        </div>
                        
                        <div className="bg-gray-50 rounded-xl p-6">
                            <h4 className="font-bold text-gray-800 mb-4 flex items-center">
                                <span className="text-2xl mr-2">💔</span> The Impact
                            </h4>
                            <ul className="space-y-3 text-gray-700">
                                <li className="flex items-start">
                                    <span className="text-gray-400 mr-2">•</span>
                                    <div>
                                        <span className="font-semibold">70% give up</span> before finding help
                                    </div>
                                </li>
                                <li className="flex items-start">
                                    <span className="text-gray-400 mr-2">•</span>
                                    <div>
                                        <span className="font-semibold">Average 3 therapists</span> before finding a fit
                                    </div>
                                </li>
                                <li className="flex items-start">
                                    <span className="text-gray-400 mr-2">•</span>
                                    <div>
                                        <span className="font-semibold">Months wasted</span> in trial and error
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    
                    <div className="bg-purple-50 rounded-xl p-6 text-center">
                        <p className="text-lg text-gray-800 mb-2">
                            <span className="font-bold text-purple-600">The Missing Piece:</span>
                        </p>
                        <p className="text-xl font-semibold text-gray-800">
                            No one is matching based on what actually matters —
                        </p>
                        <p className="text-lg text-purple-600 font-bold mt-2">
                            personality, communication style, and therapeutic rapport
                        </p>
                    </div>
                </div>
                
                <div className="text-center">
                    <p className="text-xl text-gray-300">
                        It's not about finding <span className="text-white font-semibold">any</span> therapist.
                    </p>
                    <p className="text-2xl text-purple-400 font-bold mt-2">
                        It's about finding <span className="text-white">the right one</span>.
                    </p>
                </div>
            </div>
        </div>
    )
},
// New Slide 4: The Irony (insert after "The Struggle")
// Replace the market irony slide with this version that includes scandals:
{
    id: 'market-irony',
    content: (
        <div className="min-h-screen bg-gradient-to-br from-purple-900 to-gray-900 overflow-y-auto">
            <div className="max-w-7xl mx-auto px-8 py-16">
                <h2 className="text-4xl md:text-5xl font-bold mb-4 text-white text-center">
                    The $5 Billion Irony
                </h2>
                <p className="text-xl text-purple-300 text-center mb-12">
                    Scandal-ridden platforms printing money from desperate users
                </p>
                
                {/* Large summary cards */}
                <div className="grid md:grid-cols-2 gap-8 mb-12">
                    <div className="bg-gradient-to-br from-red-900/30 to-gray-900/30 backdrop-blur-lg rounded-2xl p-8 border border-red-500/20">
                        <h3 className="text-3xl font-bold text-white mb-6">The Ugly Truth</h3>
                        <div className="space-y-4">
                            <div>
                                <span className="text-red-400 font-bold">BetterHelp:</span>
                                <span className="text-white"> $1B revenue</span>
                                <p className="text-sm text-gray-300 ml-4">→ Sold user data to Facebook</p>
                                <p className="text-sm text-gray-300 ml-4">→ $93M in refunds, FTC investigation</p>
                            </div>
                            <div>
                                <span className="text-red-400 font-bold">Talkspace:</span>
                                <span className="text-white"> $188M revenue</span>
                                <p className="text-sm text-gray-300 ml-4">→ CEO resigned in scandal</p>
                                <p className="text-sm text-gray-300 ml-4">→ Pays therapists $20/hour</p>
                            </div>
                            <div>
                                <span className="text-purple-400 font-bold">Calm/Headspace:</span>
                                <span className="text-white"> $5.2B combined valuation</span>
                                <p className="text-sm text-gray-300 ml-4">→ Meditation apps pretending to be therapy</p>
                                <p className="text-sm text-gray-300 ml-4">→ Downloads down 70%</p>
                            </div>
                        </div>
                    </div>
                    
                    <div className="bg-gradient-to-br from-green-900/30 to-gray-900/30 backdrop-blur-lg rounded-2xl p-8 border border-green-500/20">
                        <h3 className="text-3xl font-bold text-white mb-6">The Opportunity</h3>
                        <div className="space-y-4 text-lg">
                            <p className="text-white">
                                <span className="text-4xl font-bold text-green-400 block mb-2">$6.7B</span>
                                Total valuations despite failures
                            </p>
                            <p className="text-white">
                                <span className="text-4xl font-bold text-green-400 block mb-2">$1.7B+</span>
                                Annual revenue from broken solutions
                            </p>
                            <p className="text-white">
                                <span className="text-4xl font-bold text-yellow-400 block mb-2">0</span>
                                Platforms matching on personality fit
                            </p>
                            <p className="text-white">
                                <span className="text-4xl font-bold text-green-400 block mb-2">50M+</span>
                                Americans desperate for real help
                            </p>
                        </div>
                    </div>
                </div>
                
                {/* Bottom message */}
                <div className="bg-white rounded-2xl p-6 text-center max-w-4xl mx-auto mb-20">
                    <p className="text-2xl font-bold text-gray-800 mb-2">
                        They proved the market. We'll capture it.
                    </p>
                    <p className="text-lg text-gray-600">
                        First platform to match on <span className="text-purple-600 font-bold">actual therapeutic fit</span>, not ZIP code
                    </p>
                </div>
            </div>
        </div>
    )
},

		// Slide 4: The Statistics
		{
			id: 'statistics',
			content: (
				<div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 to-purple-900">
					<div className="max-w-6xl mx-auto px-8 text-center">
						<h2 className="text-4xl md:text-5xl font-bold mb-16 text-white">
							Sarah Isn't Alone
						</h2>
						<div className="grid md:grid-cols-3 gap-8 mb-12">
							<div className="bg-white bg-opacity-10 backdrop-blur-lg rounded-2xl p-8 border border-white border-opacity-20">
								<p className="text-6xl font-bold text-purple-400 mb-4">70%</p>
								<p className="text-white text-lg">abandon their search for a therapist</p>
							</div>
							<div className="bg-white bg-opacity-10 backdrop-blur-lg rounded-2xl p-8 border border-white border-opacity-20">
								<p className="text-6xl font-bold text-purple-400 mb-4">75%</p>
								<p className="text-white text-lg">who do find someone quit within 3 sessions</p>
							</div>
							<div className="bg-white bg-opacity-10 backdrop-blur-lg rounded-2xl p-8 border border-white border-opacity-20">
								<p className="text-6xl font-bold text-purple-400 mb-4">50M+</p>
								<p className="text-white text-lg">Americans need therapy but can't find the right match</p>
							</div>
						</div>
						<p className="text-2xl text-gray-300 italic">
							The system is broken. But what if it didn't have to be?
						</p>
					</div>
				</div>
			)
		},

		// Slide 5: Enter Mindaera
		{
			id: 'enter-mindaera',
			content: (
				<div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-600 via-purple-600 to-blue-700">
					<div className="max-w-5xl mx-auto px-8 text-center">
						<h2 className="text-5xl md:text-6xl font-bold mb-8 text-white">
							What if finding help was as easy as having a conversation?
						</h2>
						<div className="bg-white rounded-3xl p-12 shadow-2xl">
							<div className="mb-8">
								<div className="w-20 h-20 bg-gradient-to-br from-purple-500 to-blue-500 rounded-2xl flex items-center justify-center mx-auto mb-6">
									<Sparkles className="w-12 h-12 text-white" />
								</div>
							</div>
							<h3 className="text-3xl font-bold text-gray-800 mb-6">
								Introducing Mindaera
							</h3>
							<p className="text-xl text-gray-600 leading-relaxed">
								Where AI meets the expertise of world-class therapists to find your perfect match through natural conversation
							</p>
						</div>
					</div>
				</div>
			)
		},

		// Slide 6: The Experience - Amy
		{
			id: 'amy-conversation',
			content: (
				<div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-600 via-purple-600 to-blue-700">
					<div className="max-w-5xl mx-auto px-8">
						<h2 className="text-4xl md:text-5xl font-bold mb-12 text-white text-center">
							Sarah Discovers Mindaera
						</h2>
						<div className="bg-white rounded-3xl p-8 shadow-2xl">
							<div className="text-center mb-8">
								<p className="text-2xl font-semibold text-gray-800 mb-6">
									"Hi Sarah, I'm Amy. How are you feeling today?"
								</p>
								<div className="flex justify-center items-center space-x-8 mb-8">
									{/* Voice Wave Animation */}
									<div className="flex items-center space-x-1">
										<div className="w-1 h-8 bg-purple-500 rounded-full animate-pulse"></div>
										<div className="w-1 h-12 bg-purple-500 rounded-full animate-pulse" style={{animationDelay: '0.1s'}}></div>
										<div className="w-1 h-16 bg-purple-500 rounded-full animate-pulse" style={{animationDelay: '0.2s'}}></div>
										<div className="w-1 h-20 bg-purple-500 rounded-full animate-pulse" style={{animationDelay: '0.3s'}}></div>
										<div className="w-1 h-16 bg-purple-500 rounded-full animate-pulse" style={{animationDelay: '0.4s'}}></div>
										<div className="w-1 h-12 bg-purple-500 rounded-full animate-pulse" style={{animationDelay: '0.5s'}}></div>
										<div className="w-1 h-8 bg-purple-500 rounded-full animate-pulse" style={{animationDelay: '0.6s'}}></div>
									</div>
									{/* Microphone Icon */}
									<div className="w-20 h-20 bg-gradient-to-br from-purple-500 to-blue-500 rounded-full flex items-center justify-center animate-pulse">
										<svg className="w-10 h-10 text-white" fill="currentColor" viewBox="0 0 20 20">
											<path fillRule="evenodd" d="M7 4a3 3 0 016 0v4a3 3 0 11-6 0V4zm4 10.93A7.001 7.001 0 0017 8a1 1 0 10-2 0A5 5 0 015 8a1 1 0 00-2 0 7.001 7.001 0 006 6.93V17H6a1 1 0 100 2h8a1 1 0 100-2h-3v-2.07z" clipRule="evenodd" />
										</svg>
									</div>
									{/* Voice Wave Animation */}
									<div className="flex items-center space-x-1">
										<div className="w-1 h-8 bg-blue-500 rounded-full animate-pulse" style={{animationDelay: '0.6s'}}></div>
										<div className="w-1 h-12 bg-blue-500 rounded-full animate-pulse" style={{animationDelay: '0.5s'}}></div>
										<div className="w-1 h-16 bg-blue-500 rounded-full animate-pulse" style={{animationDelay: '0.4s'}}></div>
										<div className="w-1 h-20 bg-blue-500 rounded-full animate-pulse" style={{animationDelay: '0.3s'}}></div>
										<div className="w-1 h-16 bg-blue-500 rounded-full animate-pulse" style={{animationDelay: '0.2s'}}></div>
										<div className="w-1 h-12 bg-blue-500 rounded-full animate-pulse" style={{animationDelay: '0.1s'}}></div>
										<div className="w-1 h-8 bg-blue-500 rounded-full animate-pulse"></div>
									</div>
								</div>
								<p className="text-lg text-gray-600 italic mb-4">
									"Honestly? Pretty overwhelmed. Work has been stressful..."
								</p>
								<p className="text-gray-500">
									Sarah speaks naturally, just like she would to a friend
								</p>
							</div>
							<div className="border-t pt-6">
								<div className="grid md:grid-cols-3 gap-4 text-center">
									<div>
										<p className="text-3xl font-bold text-purple-600">100%</p>
										<p className="text-sm text-gray-600">Voice-based</p>
									</div>
									<div>
										<p className="text-3xl font-bold text-blue-600">Natural</p>
										<p className="text-sm text-gray-600">Conversation flow</p>
									</div>
									<div>
										<p className="text-3xl font-bold text-green-600">Empathetic</p>
										<p className="text-sm text-gray-600">Understanding</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)
		},

		// Slide 7: The Magic Behind
		{
			id: 'the-magic',
			content: (
				<div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 to-purple-900">
					<div className="max-w-6xl mx-auto px-8">
						<h2 className="text-4xl md:text-5xl font-bold mb-12 text-white text-center">
							The Revolutionary Science of Perfect Matching
						</h2>
						<div className="bg-white rounded-3xl p-8 shadow-2xl mb-8">
							<h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">It's Not Just About Finding Any Therapist</h3>
							<div className="grid md:grid-cols-2 gap-8">
								<div className="bg-purple-50 rounded-xl p-6">
									<h4 className="font-bold text-purple-800 mb-3">Traditional Matching</h4>
									<ul className="space-y-2 text-gray-700">
										<li>• Focus only on specialization</li>
										<li>• Ignore personality fit</li>
										<li>• Therapists waste energy bridging gaps</li>
										<li>• Clients feel misunderstood</li>
									</ul>
								</div>
								<div className="bg-green-50 rounded-xl p-6">
									<h4 className="font-bold text-green-800 mb-3">Mindaera's Approach</h4>
									<ul className="space-y-2 text-gray-700">
										<li>• Match on 100+ dimensions</li>
										<li>• Natural connection from day one</li>
										<li>• Therapists focus purely on healing</li>
										<li>• Clients feel truly understood</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="bg-white bg-opacity-10 backdrop-blur-lg rounded-2xl p-8 border border-white border-opacity-20">
							<p className="text-xl text-white text-center mb-4">
								<span className="font-bold text-purple-400">Our Secret:</span> When values, communication styles, and worldviews align naturally, 
								<span className="font-bold"> both therapist and client</span> can focus 100% on healing - not translation.
							</p>
							<p className="text-sm text-gray-300 text-center italic">
								Powered by proprietary AI models and 20+ years of clinical insights
							</p>
						</div>
					</div>
				</div>
			)
		},

		// Slide 8: The Perfect Match
		{
    id: 'perfect-match',
    content: (
        <div className="min-h-full flex items-center justify-center bg-gradient-to-br from-blue-600 via-purple-600 to-blue-700 p-4 sm:p-8">
            <div className="max-w-5xl mx-auto w-full">
                <h2 className="text-4xl md:text-5xl font-bold mb-8 text-white text-center">
                    The Perfect Match
                </h2>
                <div className="bg-white rounded-3xl p-6 shadow-2xl">
                    <div className="text-center mb-6">
                        <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
                        <p className="text-2xl font-semibold text-gray-800">
                            "Sarah, I think Dr. Emily Chen would be perfect for you"
                        </p>
                    </div>
                    
                    {/* Two column comparison */}
                    <div className="grid md:grid-cols-2 gap-6 mb-6">
                        <div className="bg-gray-50 rounded-xl p-4">
                            <h3 className="font-bold text-gray-800 mb-3 text-center">Traditional Matching ✓</h3>
                            <ul className="space-y-2 text-sm text-gray-700">
                                <li className="flex items-start">
                                    <CheckCircle className="w-4 h-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                                    <span>Specializes in workplace anxiety</span>
                                </li>
                                <li className="flex items-start">
                                    <CheckCircle className="w-4 h-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                                    <span>Takes your insurance</span>
                                </li>
                                <li className="flex items-start">
                                    <CheckCircle className="w-4 h-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                                    <span>Available Tuesday evenings</span>
                                </li>
                                <li className="flex items-start">
                                    <CheckCircle className="w-4 h-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                                    <span>Good reviews online</span>
                                </li>
                            </ul>
                        </div>
                        
                        <div className="bg-gradient-to-br from-purple-50 to-blue-50 rounded-xl p-4 border-2 border-purple-200">
                            <h3 className="font-bold text-purple-800 mb-3 text-center">Mindaera's Deep Match ✨</h3>
                            <ul className="space-y-2 text-sm text-gray-700">
                                <li className="flex items-start">
                                    <Sparkles className="w-4 h-4 text-purple-500 mr-2 mt-0.5 flex-shrink-0" />
                                    <span><strong>Personality harmony</strong> - both analytical thinkers</span>
                                </li>
                                <li className="flex items-start">
                                    <Sparkles className="w-4 h-4 text-purple-500 mr-2 mt-0.5 flex-shrink-0" />
                                    <span><strong>Identical processing style</strong> - visual learners</span>
                                </li>
                                <li className="flex items-start">
                                    <Sparkles className="w-4 h-4 text-purple-500 mr-2 mt-0.5 flex-shrink-0" />
                                    <span><strong>Matching life philosophy</strong> - growth mindset</span>
                                </li>
                                <li className="flex items-start">
                                    <Sparkles className="w-4 h-4 text-purple-500 mr-2 mt-0.5 flex-shrink-0" />
                                    <span><strong>Communication resonance</strong> - direct & clear</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    
                    <div className="bg-green-50 rounded-xl p-4 mb-4 border border-green-200">
                        <p className="text-center text-gray-800 font-semibold">
                            Result: No awkward "getting to know you" phase. 
                            <span className="text-green-600"> Instant connection from session one.</span>
                        </p>
                    </div>
                    
                    <button className="w-full bg-gradient-to-r from-purple-600 to-blue-600 text-white font-semibold py-4 rounded-xl hover:shadow-lg transition-all">
                        Book Your First Session
                    </button>
                </div>
            </div>
        </div>
    )
},

		// Replace Slide 9: The Perfect Match


		// Slide 10: The Vision
		{
			id: 'vision',
			content: (
				<div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-900 via-blue-900 to-purple-900">
					<div className="max-w-6xl mx-auto px-8 text-center">
						<h2 className="text-5xl md:text-6xl font-bold mb-12 text-white">
							Every Person Deserves Their Perfect Therapist Match
						</h2>
						<div className="grid md:grid-cols-2 gap-8 mb-12">
							<div className="bg-white bg-opacity-10 backdrop-blur-lg rounded-2xl p-8 border border-white border-opacity-20">
								<h3 className="text-2xl font-bold text-white mb-4">For Clients</h3>
								<ul className="text-left text-gray-200 space-y-3">
									<li>• No more endless searching</li>
									<li>• No more wrong matches</li>
									<li>• No more giving up on getting help</li>
									<li>• Just healing, from day one</li>
								</ul>
							</div>
							<div className="bg-white bg-opacity-10 backdrop-blur-lg rounded-2xl p-8 border border-white border-opacity-20">
								<h3 className="text-2xl font-bold text-white mb-4">For Therapists</h3>
								<ul className="text-left text-gray-200 space-y-3">
									<li>• Clients who are perfectly matched</li>
									<li>• AI-powered session insights</li>
									<li>• Better therapeutic outcomes</li>
									<li>• Focus on what you do best: healing</li>
								</ul>
							</div>
						</div>
						<p className="text-2xl text-purple-200">
							We're building the future of mental healthcare, one perfect match at a time
						</p>
					</div>
				</div>
			)
		},

		// New Slide 9: Trust & Security
{
    id: 'trust-security',
    content: (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 to-blue-900">
            <div className="max-w-5xl mx-auto px-8">
                <h2 className="text-4xl md:text-5xl font-bold mb-12 text-white text-center">
                    Built on Trust, Secured by Design
                </h2>
                <div className="grid md:grid-cols-2 gap-8">
                    <div className="bg-white rounded-2xl p-8">
                        <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center mb-4">
                            <AlertCircle className="w-10 h-10 text-blue-600" />
                        </div>
                        <h3 className="text-xl font-bold text-gray-800 mb-4">Complete Confidentiality</h3>
                        <ul className="space-y-3 text-gray-700">
                            <li className="flex items-start">
                                <CheckCircle className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                                <span>End-to-end encryption for all conversations</span>
                            </li>
                            <li className="flex items-start">
                                <CheckCircle className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                                <span>HIPAA-compliant infrastructure</span>
                            </li>
                            <li className="flex items-start">
                                <CheckCircle className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                                <span>No data sharing without explicit consent</span>
                            </li>
                        </ul>
                    </div>
                    <div className="bg-white rounded-2xl p-8">
                        <div className="w-16 h-16 bg-purple-100 rounded-xl flex items-center justify-center mb-4">
                            <Brain className="w-10 h-10 text-purple-600" />
                        </div>
                        <h3 className="text-xl font-bold text-gray-800 mb-4">Clinical Oversight</h3>
                        <ul className="space-y-3 text-gray-700">
                            <li className="flex items-start">
                                <CheckCircle className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                                <span>Every AI interaction clinically reviewed</span>
                            </li>
                            <li className="flex items-start">
                                <CheckCircle className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                                <span>No rogue AI - guardrails at every step</span>
                            </li>
                            <li className="flex items-start">
                                <CheckCircle className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                                <span>Continuous safety monitoring</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="mt-8 bg-white bg-opacity-10 backdrop-blur-lg rounded-2xl p-6 border border-white border-opacity-20 text-center">
                    <p className="text-lg text-white">
                        Our proprietary matching algorithms and processes are protected by advanced security measures, 
                        ensuring our innovation remains secure while your data remains private.
                    </p>
                </div>
            </div>
        </div>
    )
},

		// Slide 11: The Team
{
    id: 'team',
    content: (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 to-blue-900 overflow-y-auto">
            <div className="max-w-6xl mx-auto px-8 py-16">
                <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white text-center">
                    Created by Leading European and US Psychology Professionals
                </h2>
                <p className="text-xl text-gray-300 text-center mb-4">
                    Founders of Addicere, Peak Neuropsychology and Realfied
                </p>
                <p className="text-lg text-center mb-12 max-w-3xl mx-auto">
                    <span className="text-gray-400">We've spent decades in therapy rooms and tech labs.</span>{' '}
                    <span className="text-purple-400 font-bold">We built Amy because we've seen the struggle firsthand.</span>
                </p>
                
                <div className="grid md:grid-cols-3 gap-8 mb-8">
                    <div className="text-center">
                        <div className="relative rounded-2xl overflow-hidden border border-purple-500/20 mb-4">
                            <img 
                                src="/images/david.jpg" 
                                alt="Dr. David Stephens"
                                className="w-full h-72 object-cover object-top"
                            />
                        </div>
                        <h3 className="text-xl font-bold text-white mb-2">Dr. David Stephens</h3>
                        <p className="text-purple-300 font-semibold mb-3">Chief Psychology Officer</p>
                        <p className="text-sm text-gray-300">Former Dean of University of the Rockies and Director of Mental Health of Missouri and Colorado. 35+ years experience.</p>
                    </div>
                    
                    <div className="text-center">
                        <div className="relative rounded-2xl overflow-hidden border border-blue-500/20 mb-4">
                            <img 
                                src="/images/erik.jpg" 
                                alt="Erik Rüütel"
                                className="w-full h-72 object-cover object-top"
                            />
                        </div>
                        <h3 className="text-xl font-bold text-white mb-2">Erik Rüütel</h3>
                        <p className="text-blue-300 font-semibold mb-3">Chief Executive Officer</p>
                        <p className="text-sm text-gray-300">Executive Psychological Crisis Advisor, Former Deputy Governor of Tallinn Prison, runs 10,000 clients practice</p>
                    </div>
                    
                    <div className="text-center">
                        <div className="relative rounded-2xl overflow-hidden border border-green-500/20 mb-4">
                            <img 
                                src="/images/youssef.jpg" 
                                alt="Youssef El Moumni"
                                className="w-full h-72 object-cover object-top"
                            />
                        </div>
                        <h3 className="text-xl font-bold text-white mb-2">Youssef El Moumni</h3>
                        <p className="text-green-300 font-semibold mb-3">Chief Technology Officer</p>
                        <p className="text-sm text-gray-300">Performance Engineer, 3x Founder, 2x Patent Holder, AI Pioneer</p>
                    </div>
                </div>
                
                <div className="space-y-4 mb-20">
                    <div className="bg-white bg-opacity-10 backdrop-blur-lg rounded-2xl p-6 border border-white border-opacity-20">
                        <p className="text-lg text-white text-center">
                            <span className="font-bold text-purple-400">Combined Experience:</span> 60+ years in mental health, 
                            30,000+ patients treated, 3 successful practices built, multiple AI innovations
                        </p>
                    </div>
                    <div className="bg-white bg-opacity-10 backdrop-blur-lg rounded-2xl p-6 border border-white border-opacity-20">
                        <p className="text-lg text-white text-center">
                            <span className="font-bold text-green-400">Our advantage:</span> We understand both the human psyche 
                            and the technology to unlock perfect therapeutic connections at scale
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
},

		// Slide 12: The Ask
		// Replace Slide 14: The Ask
{
    id: 'the-ask',
    content: (
        <div className="min-h-full flex items-center justify-center bg-gradient-to-br from-blue-600 via-purple-600 to-blue-700 p-4 sm:p-8">
            <div className="text-center max-w-5xl mx-auto w-full">
                <h2 className="text-5xl md:text-6xl font-bold mb-8 text-white">
                    Join Us in Revolutionizing Mental Healthcare
                </h2>
                <div className="bg-white rounded-3xl p-8 shadow-2xl">
                    <div className="mb-8">
                        <h3 className="text-3xl font-bold text-gray-800 mb-6">We're Raising $2M Seed Round</h3>
                        <div className="grid md:grid-cols-3 gap-6 mb-8">
                            <div className="bg-purple-50 rounded-xl p-6">
                                <TrendingUp className="w-8 h-8 text-purple-600 mx-auto mb-3" />
                                <p className="font-semibold text-gray-800">Enhance AI Platform</p>
                                <p className="text-sm text-gray-600 mt-2">Voice recognition, continuity, therapist insights</p>
                            </div>
                            <div className="bg-blue-50 rounded-xl p-6">
                                <Users className="w-8 h-8 text-blue-600 mx-auto mb-3" />
                                <p className="font-semibold text-gray-800">Scale Network</p>
                                <p className="text-sm text-gray-600 mt-2">1,000+ therapists, insurance integration</p>
                            </div>
                            <div className="bg-green-50 rounded-xl p-6">
                                <Target className="w-8 h-8 text-green-600 mx-auto mb-3" />
                                <p className="font-semibold text-gray-800">Launch Nationwide</p>
                                <p className="text-sm text-gray-600 mt-2">100,000+ perfect matches in Year 1</p>
                            </div>
                        </div>
                    </div>
                    
                    <div className="border-t pt-8">
                        <h4 className="text-2xl font-bold text-gray-800 mb-6">Let's Talk</h4>
                        <form 
                            onSubmit={async (e) => {
								e.preventDefault();
								const formData = new FormData(e.target);
								const submitButton = e.target.querySelector('button[type="submit"]');
								const originalText = submitButton.textContent;
								
								try {
									submitButton.disabled = true;
									submitButton.textContent = 'Sending...';
									
									const response = await fetch('/api/contact', {
										method: 'POST',
										headers: {
											'Content-Type': 'application/json'
										},
										body: JSON.stringify({
											name: formData.get('name'),
											email: formData.get('email'),
											message: formData.get('message')
										})
									});
									
									const data = await response.json();
									
									if (response.ok) {
										submitButton.textContent = 'Sent! ✓';
										submitButton.classList.add('bg-green-600');
										e.target.reset();
										setTimeout(() => {
											submitButton.textContent = originalText;
											submitButton.classList.remove('bg-green-600');
											submitButton.disabled = false;
										}, 3000);
									} else {
										throw new Error(data.error || 'Failed to send');
									}
								} catch (error) {
									console.error('Error sending email:', error);
									submitButton.textContent = 'Error - Try Again';
									submitButton.classList.add('bg-red-600');
									setTimeout(() => {
										submitButton.textContent = originalText;
										submitButton.classList.remove('bg-red-600');
										submitButton.disabled = false;
									}, 3000);
								}
							}}
                            className="max-w-md mx-auto"
                        >
                            <div className="space-y-4">
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Your Name"
                                    required
                                    className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-purple-500 focus:ring-2 focus:ring-purple-200 outline-none transition-all"
                                />
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Your Email"
                                    required
                                    className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-purple-500 focus:ring-2 focus:ring-purple-200 outline-none transition-all"
                                />
                                <textarea
                                    name="message"
                                    placeholder="Tell us about your interest in Mindaera"
                                    rows="3"
                                    required
                                    className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-purple-500 focus:ring-2 focus:ring-purple-200 outline-none transition-all resize-none"
                                />
                                <button
                                    type="submit"
                                    className="w-full bg-gradient-to-r from-purple-600 to-blue-600 text-white font-bold py-4 rounded-xl hover:shadow-lg transition-all text-lg flex items-center justify-center"
                                >
                                    Send Message
                                    <ArrowRight className="ml-2" size={20} />
                                </button>
                            </div>
                        </form>
                        
                        <div className="mt-6 text-sm text-gray-600">
                            <p className="font-semibold">Quick Stats:</p>
                            <p>• $5B+ therapy market growing 8% annually</p>
                            <p>• First-mover in AI-powered voice matching</p>
                            <p>• 95% match satisfaction in beta</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
	];

	const handleKeyPress = (e) => {
		if (e.key === 'ArrowRight' || e.key === ' ') {
			nextSlide();
		} else if (e.key === 'ArrowLeft') {
			prevSlide();
		}
	};

	const nextSlide = () => {
		if (currentSlide < slides.length - 1) {
			setCurrentSlide(currentSlide + 1);
		}
	};

	const prevSlide = () => {
		if (currentSlide > 0) {
			setCurrentSlide(currentSlide - 1);
		}
	};

	useEffect(() => {
		window.addEventListener('keydown', handleKeyPress);
		return () => window.removeEventListener('keydown', handleKeyPress);
	}, [currentSlide]);

	return (
<div 
	className="relative w-full h-screen overflow-auto hide-scrollbar"
	onTouchStart={onTouchStart}
	onTouchMove={onTouchMove}
	onTouchEnd={onTouchEnd}
>			{/* Current Slide */}
			<div className="w-full h-full">
				{slides[currentSlide].content}
			</div>


{/* Navigation */}
<div className="fixed bottom-0 left-0 right-0 bg-black bg-opacity-50 backdrop-blur-lg p-4 z-50">
    <div className="max-w-4xl mx-auto flex items-center justify-center space-x-4">
        <button
            onClick={prevSlide}
            disabled={currentSlide === 0}
            className={`p-3 rounded-full ${
                currentSlide === 0
                    ? 'bg-gray-600 opacity-50 cursor-not-allowed'
                    : 'bg-white bg-opacity-20 backdrop-blur-lg hover:bg-opacity-30'
            } transition-all`}
        >
            <ChevronLeft className="w-6 h-6 text-white" />
        </button>
        
        <div className="flex space-x-2">
            {slides.map((_, index) => (
                <button
                    key={index}
                    onClick={() => setCurrentSlide(index)}
                    className={`w-2 h-2 rounded-full transition-all ${
                        index === currentSlide
                            ? 'bg-white w-8'
                            : 'bg-white bg-opacity-40'
                    }`}
                />
            ))}
        </div>
        
        <button
            onClick={nextSlide}
            disabled={currentSlide === slides.length - 1}
            className={`p-3 rounded-full ${
                currentSlide === slides.length - 1
                    ? 'bg-gray-600 opacity-50 cursor-not-allowed'
                    : 'bg-white bg-opacity-20 backdrop-blur-lg hover:bg-opacity-30'
            } transition-all`}
        >
            <ChevronRight className="w-6 h-6 text-white" />
        </button>
    </div>
</div>

{/* Slide Counter - moved to top right */}
<div className="fixed top-4 right-4 text-white text-sm bg-black bg-opacity-50 backdrop-blur-lg px-4 py-2 rounded-full z-50">
    {currentSlide + 1} / {slides.length}
</div>

{/* Instructions - now part of navigation bar on desktop, hidden on mobile */}
<div className="fixed bottom-4 right-4 text-white text-xs bg-black bg-opacity-50 backdrop-blur-lg px-4 py-2 rounded-lg z-50 hidden md:block">
    Use arrow keys or buttons to navigate
</div>
		</div>
	);
};

export default MindaeraPitchDeck;